export default "__VITE_ASSET__BoX8Cb2T__"